import React from 'react';
import { Checkbox } from 'primereact/checkbox';
import { FormattedMessage } from 'react-intl';
import { Gr8piFormattedDate } from '../../../components/Gr8piFormattedDateTime';

const GpiThirdPartiesContactAgreement = ({
  updateAgreement,
  agreedToBeContactedByGpiPartners,
  gpiPartnersContactAgreementUpdatedOn,
}) => {
  return (
    <>
      <div>
        <Checkbox
          id="agreedToBeContactedByGpiPartners"
          value={agreedToBeContactedByGpiPartners}
          onChange={(event) => updateAgreement(event)}
          checked={!!agreedToBeContactedByGpiPartners}
        />
        <span> </span>
        <label htmlFor="updateGpiPartnersAgreement" className="p-checkbox-label">
          <FormattedMessage
            id="user.communication-settings.gpi-third-parties-contact-agreement"
            defaultMessage="Information from GPI Third-parties, including newsletters, marketing, etc."
            tagName="strong"
          />
        </label>
      </div>
      <br />
      <div>
        <FormattedMessage id="user.communication-settings.updatedOn" defaultMessage="Updated on: " tagName="strong" />
        <span>
          {gpiPartnersContactAgreementUpdatedOn && (
            <Gr8piFormattedDate dateValue={gpiPartnersContactAgreementUpdatedOn} />
          )}
        </span>
      </div>
    </>
  );
};

export default GpiThirdPartiesContactAgreement;
